<template>
  <ul :class="bemBlock">
    <li
      v-for="item in breadcrumbs"
      :key="item.name"
      :class="bemElement('list-item')"
    >
      <a
        v-if="item !== lastBreadcrumb"
        :href="item.url"
        :class="[
          bemElement('link', {
            disabled: item.byl_renderType,
          }),
          'link',
          'interaction--enabled-hover-v1'
        ]"
      >{{ item.name }}</a>
      <span
        v-else-if="breadcrumbNotAsH1"
      >{{ item.name }}</span>
      <h1
        v-else
      >
        {{ item.name }}
      </h1>
    </li>
  </ul>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'TheProductListBreadcrumbs',

  mixins: [
    bemClassesMixin,
  ],

  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    breadcrumbNotAsH1: {
      type: Boolean,
    },
  },

  computed: {
    lastBreadcrumb() {
      return this.breadcrumbs.slice(-1)[0];
    },
  },
};
</script>
